import React from 'react';
import { ExpandableNode } from '@bingads-webui-react/tree-view';

export function TreeNodeRenderer() {
  return (node, args) => (
    <ExpandableNode node={node} singleClickExpansion {...args}>{
      args.nodeChildRenderer(node)
    }
    </ExpandableNode>);
}
